import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20abstract%20corporate%20background%20with%20warm%20amber%20and%20golden%20geometric%20patterns%2C%20soft%20overlapping%20circles%20and%20flowing%20curved%20lines%20representing%20business%20growth%20and%20sales%20success%2C%20clean%20minimalist%20aesthetic%2C%20subtle%20gradients%20from%20warm%20amber%20to%20cream%2C%20sophisticated%20Japanese%20corporate%20atmosphere%2C%20high%20end%20consulting%20firm%20visual%20identity%2C%20no%20text%2C%20soft%20diffused%20lighting&width=1800&height=1200&seq=dream-hero-2026&orientation=landscape"
        alt="株式会社Ｄｒｅａｍ 営業支援・コンサルティング"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-primary-300 text-sm md:text-base font-medium tracking-widest mb-4 animate-fade-in-up">
            SALES SUPPORT &amp; CONSULTING
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-fade-in-up animation-delay-200">
            御社の<span className="text-primary-400">成長</span>を、<br className="hidden sm:block" />
            全力で支えるパートナー
          </h1>
          <p className="text-white/75 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in-up animation-delay-400">
            営業支援からコンサルティング、システム開発まで。<br className="hidden sm:block" />
            株式会社Ｄｒｅａｍは、ビジネスのあらゆる局面でお客様と伴走します。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up animation-delay-600">
            <Link
              to="/contact"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold rounded-md whitespace-nowrap cursor-pointer transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600 hover:scale-105"
            >
              まずは相談する
            </Link>
            <Link
              to="/pricing"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium rounded-md whitespace-nowrap cursor-pointer transition-all duration-200 border border-white/30 text-white hover:bg-white/10 hover:border-white/50"
            >
              料金プランを見る
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl" />
      </div>
    </section>
  );
}